import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { CloseOnOutsideDirective } from '@awread/global/packages';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faAngleDown, faPlusCircle, faPencil, faTrash, faEllipsis } from '@fortawesome/free-solid-svg-icons';
import { CopyClipboardDirective } from '../../directives/copy-clipboard/copy-clipboard.directive.js';

@Component({
  standalone: true,
  selector: 'list-social-menu',
  imports: [CommonModule, CloseOnOutsideDirective, FontAwesomeModule, CopyClipboardDirective],
  templateUrl: './list-social-menu.atom.html',
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListSocialMenuAtom implements OnInit {
  @Input() contestNid!: any;
  @Input() faIcon = window.innerWidth <= 768 ? faEllipsis : faAngleDown;
  @Input() previewLink: any;
  @Input() labelText = 'Edit';
  @Input() bookId!: string;
  @Input() faIconBtn = faAngleDown;
  @Input() actions = [
    {
      name: 'Thêm chương',
      type: 'create-chapter',
      icon: faPlusCircle,
    },
    {
      name: 'Chỉnh sửa',
      type: 'edit',
      icon: faPencil,
    },
    {
      name: 'Xóa',
      type: 'delete',
      icon: faTrash,
    },
  ];
  @Output() bookActionEvent = new EventEmitter();
  isMenuOpen = false;
  constructor() {}
  toggleMenu(event: any) {
    event.stopPropagation();
    this.isMenuOpen = !this.isMenuOpen;
  }

  onClick() {
    this.isMenuOpen = false;
  }

  ngOnInit(): void {}
  // add chapter, edit book
  handleBookAction(type: string) {
    this.bookActionEvent.emit(type);
  }
}
